export const KEYS = {
  DOWN: 'ArrowDown',
  UP: 'ArrowUp',
  ENTER: 'Enter',
  TAB: 'Tab',
  SHIFT: 'Shift'
}
